export default "__VITE_ASSET__Bkox5Dwe__"